import React from "react";
import AppTable from "components/Shared/AppTable";
import AppTableDateTime from "components/Shared/AppTableDateTime";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useGetShipmentMessagesByShipmentIdQuery } from "store/services/smsLogListApi";

const ShipmentSmsLogTab = ({ shipmentId }) => {
  const {
    data: messagesRes,
    isLoading,
    isFetching,
    error,
  } = useGetShipmentMessagesByShipmentIdQuery(shipmentId, {
    skip: !shipmentId,
  });

  const columns = [
    {
      name: "Message Type",
      selector: (row) => row.messageType,
      cell: (row) => row.messageType || "N/A",
    },
    {
      name: "Message",
      selector: (row) => row.message,
      cell: (row) => (
        <span className="line-clamp-2">{row.message || "N/A"}</span>
      ),
      width: "900px",
    },
    {
      name: "Date",
      selector: (row) => <AppTableDateTime date={row.createdAt} />,
    },
  ];

  return (
    <>
      {error && <div>Error: {error.message}</div>}
      <AppTable
        columns={columns}
        data={messagesRes?.data ?? []}
        progressPending={isLoading || isFetching}
        paginationServer={false} // No pagination needed for single shipment logs
      />
      {(isLoading || isFetching) && <RowsSkeleton />}
    </>
  );
};

export default ShipmentSmsLogTab;
